import React from "react";
import GoalDispositionPanel from "../GoalDispositionPanel";
import type { GoalDispositionPanelProps } from "../GoalDispositionPanel";

// Re-export shared types so existing consumers keep working without changing imports.
export type { TargetAction, Target, Goal, TargetActionState } from "../GoalDispositionPanel";

export interface ArchiveGoalPanelProps
  extends Omit<GoalDispositionPanelProps, "variant" | "onSubmit"> {
  /**
   * Called with the resolved action for every target when the user confirms
   * the archive operation.
   */
  onArchive: GoalDispositionPanelProps["onSubmit"];
}

/**
 * Thin wrapper over `GoalDispositionPanel` configured for the archive flow.
 * Drives title → "Archive Goal", primary radio label → "Archive with this goal",
 * and confirm button color → primary.
 *
 * @param props - Same as `GoalDispositionPanelProps` with `onArchive` instead of `onSubmit`.
 */
const ArchiveGoalPanel: React.FC<ArchiveGoalPanelProps> = ({ onArchive, ...rest }) => (
  <GoalDispositionPanel variant="archive" onSubmit={onArchive} {...rest} />
);

export default ArchiveGoalPanel;
